export const SearchFormType = {
    Static: 1,
    Float: 2,
    Map: 3
}   